import { Routes } from '@angular/router';

export const content: Routes = [
    {
        path:'dashboard',
        loadChildren:()=> import('../modules/dashboard/dashboard.routes')
    },
    {
        path:'model-results',
        loadChildren:()=> import('../modules/ModelResults/model-results.routes')
    },
    {
        path:'batch',
        loadChildren:()=> import('../modules/BulkScoring/bulkscoring.routes')
    },
    {
        path:'user-management',
        loadChildren:()=> import('../modules/UserManagement/user-management.routes')
    },
     {
        path:'account-settings',
        loadChildren:()=> import('../modules/AccountSettings/account-settings.routes')
    },
     {
        path:'contact-support',
        loadChildren:()=> import('../modules/ContactSupport/contact-support.routes')
    }
]